<template>
  <BaseSubHeading
    size="large"
    weight="400"
    class="task__menu__moveTo custom-scroll"
  >
    <span v-if="!$wait.is('loadingTaskMoveData')">
      <button
        v-for="(taskMoveOption, index) in taskMoveOptions"
        :id="taskMoveOption.id"
        :key="index"
        v-close-popper.all
        class="task__menu-option"
        @click="taskMove(taskMoveOption)"
      >
        <div
          v-if="taskMoveOption.type === 'SPRINT'"
          class="dot"
          :class="[`is-${taskMoveOption?.sprintStatus.toLowerCase()}`]"
        />
        <Avatar
          v-if="taskMoveOption.type === 'TEAM'"
          :src="taskMoveOption.pictureUrl"
          size="sm"
          type="teamsGroup"
          class="task__menu__moveTo-avatar"
        />
        <BaseSubHeading
          size="medium"
          weight="400"
        >
          {{ taskMoveOption.label }}
        </BaseSubHeading>
      </button>
    </span>
    <span
      v-else
      class="task__menu-option pointer-none"
    >
      Loading...
    </span>
  </BaseSubHeading>
</template>

<script lang="ts">
import {
  MoveToInfo,
  SprintInfo,
  Team,
} from "@/models"
import { Options, Vue } from "vue-class-component"
import { Action, Getter } from "s-vuex-class"
import { Actions, Getters } from "@/store"
import { Emit, Prop } from "vue-property-decorator"
import { Avatar } from "@/components"
type TaskMoveType = "SPRINT" | "UNPRIORITIZED" | "TEAM"

interface TaskMoveOption {
  id: string,
  label: string,
  sprintId?: string,
  sprintStatus?: string,
  pictureUrl?: string
  teamId?: string
  type: TaskMoveType
}
const components = {
  Avatar,
}
@Options({
  name: "TaskMoveTo",
  components,
})

export default class TaskMoveTo extends Vue {
  @Prop({ default: "" }) readonly teamId: string

  @Getter(Getters.NOT_COMPLETED_SPRINTS) readonly notCompletedSprints: SprintInfo[]
  @Getter(Getters.GET_TEAMS) teams: Team[]
  @Getter(Getters.GET_SESSION_PROJECT_ID) readonly sessionProjectId: string

  @Action(Actions.NOT_COMPLETED_SPRINTS) getNotCompletedSprints: ({ teamId } : {teamId: string}) => void
  @Action(Actions.GET_TEAMS_IN_PROJECT) getTeamsInProject: (projectId: string) => Promise<Team[]>

  async created() {
    this.$wait.start("loadingTaskMoveData")
    if (this.teamId) {
      await this.getNotCompletedSprints({ teamId: this.teamId })
    } else {
      await this.getTeamsInProject(this.sessionProjectId)
    }
    this.$wait.end("loadingTaskMoveData")
  }

  get taskMoveOptions() {
    let options: TaskMoveOption[] = []
    if (this.teamId) {
      this.filterSptints.forEach((sprint) => {
        options.push({
          id: `sprint_${sprint.sequenceNumber}`,
          label: `Sprint ${sprint.zeroSprint ? "Zero" : ""} #${sprint.sequenceNumber}`,
          sprintId: sprint.id,
          sprintStatus: sprint.status,
          type: "SPRINT",
          teamId: this.teamId,
        })
      })
      options.push({
        id: "unprioritizedBacklog",
        label: "Unprioritized Backlog",
        type: "UNPRIORITIZED",
        teamId: this.teamId,
      })
    } else {
      this.teams.forEach(team => options.push({
        id: "unprioritizedBacklog",
        teamId: team.id,
        label: `${team.name} Backlog`,
        pictureUrl: team.picture?.pictureUrl ?? "",
        type: "TEAM",
      }))
    }
    return options
  }

  @Emit()
  taskMove(taskMoveOption: TaskMoveOption) {
    const { label, sprintId, id, teamId } = taskMoveOption
    const moveToInfo: MoveToInfo = {
      id,
      label,
    }
    return {
      moveToInfo,
      sprintId: sprintId ?? "",
      id,
      teamId,
    }
  }

  get filterSptints() {
    return this.notCompletedSprints.filter(e => e.status !== "STARTED")
  }
}
</script>
